import React from "react";
import { Badge } from "@/components/ui/badge";
import { useStatuses, colorClass } from "@/context/StatusContext";

const FALLBACK_LABELS = {
  open: "NDR Open",
  requested_reattempt: "Reattempt Requested",
  requested_rto: "RTO Requested",
  delivered: "Delivered",
  closed: "Closed",
};

export default function StatusBadge({ status }) {
  const { metaMap } = useStatuses();
  const meta = metaMap[status];
  const label = meta?.label || FALLBACK_LABELS[status] || status;
  const cls = meta?.cls || colorClass(meta?.color);
  return (
    <Badge variant="outline" className={`font-medium ${cls}`} data-testid={`status-badge-${status}`}>
      {label}
    </Badge>
  );
}

export function StageBadge({ stage }) {
  const { stageMap } = useStatuses();
  const meta = stageMap[stage];
  const label = meta?.label || (stage === "resolved" ? "Resolved" : "Open");
  const cls = meta?.cls || colorClass(meta?.color);
  return (
    <Badge variant="outline" className={`font-medium ${cls}`} data-testid={`stage-badge-${stage}`}>
      {label}
    </Badge>
  );
}
